import { useEffect, useRef, useState } from "react";

export default function TrackingGtm() {
  const [userAcceptsCookies, setUserAcceptsCookies] = useState(false);
  const userAcceptsCookiesRef = useRef(userAcceptsCookies);

  useEffect(() => {
    userAcceptsCookiesRef.current = userAcceptsCookies;
  }, [userAcceptsCookies]);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleConsentUpdate = () => {
      const accepted = document.cookie.includes('cookieyes-consent') &&
        document.cookie.includes('analytics:yes');
      if (accepted) {
        setUserAcceptsCookies(true);
      } else if (userAcceptsCookiesRef.current) {
        window.location.reload();
      }
    };

    document.addEventListener('cookieyes_consent_update', handleConsentUpdate);

    // Check if consent was already given on a previous visit
    handleConsentUpdate();

    return () => document.removeEventListener('cookieyes_consent_update', handleConsentUpdate);
  }, []);

  // Append GTM script to body
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (userAcceptsCookies) {
      const script = document.createElement("script");
      script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-NL5RM5BN');`;
      document.body.appendChild(script);
    }
  }, [userAcceptsCookies]);

  return (
    <></>
  );
}
